import apiClient from '@/services/api-client';

export default {
  getDomain(domain) {
    return apiClient.get(`/domains/${domain}`);
  },
};
